import { useEffect, useState } from "react";
import { useBenchmarkTakeoverStore } from "src/stores/benchmarkTakeoverStore";
import { DRAFT_PROGRESS_LABEL_MS, draftProgressLabelAt } from "src/components/TiptapDocumentSB/Draft/draftProgressLabels";

// The takeover's pen-and-ink "Writing..." mark, with the same stand-in status
// steps the normal Draft flow shows before any prose arrives. The clock starts
// when the comparison session begins, so the initial loader and an option that
// is still thinking after the other has started show the same step.
export default function WritingIndicator({ className = "" }) {
  const startedAt = useBenchmarkTakeoverStore((state) => state.startedAt);
  const [label, setLabel] = useState(() => draftProgressLabelAt(Date.now() - startedAt));

  useEffect(() => {
    const tick = () => setLabel(draftProgressLabelAt(Date.now() - startedAt));
    tick();
    const timer = setInterval(tick, Math.min(1000, DRAFT_PROGRESS_LABEL_MS));
    return () => clearInterval(timer);
  }, [startedAt]);

  return (
    <div className={`loading-writing ${className}`.trim()}>
      <span key={label}>{label}</span>
      <div className="loading-pen" aria-hidden="true">
        <svg className="loading-ink" viewBox="0 0 72 18" focusable="false">
          <path d="M2 10 C12 2, 21 16, 31 9 S50 2, 68 10"></path>
        </svg>
      </div>
    </div>
  );
}
